import { Grid, Typography } from "@mui/material"
import { Ruler } from "./components/ruler"
import { LineComponent } from "../../../../components/line"
import { Modalities } from "./components/modalities"
import { MyRent } from "./components/myRent"
import useAuth from "../../../../context/auth"
import { Constants } from "../../../../utils"
import { ModalCongratulations } from "./components/modal/congratulations"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { ModalConfirmNumber } from "./components/modal/confirmNumber"
import { ModalBusinessActivity } from "./components/modal/businessActivity"
import moment from "moment"

export const RentTab = () => {
    const { user, getData } = useAuth()
    const navigate = useNavigate()

    const { state } = useLocation()
    const [openCongratulations, setOpenCongratulations] = useState(false)
    const [openConfirmNumber, setOpenConfirmNumber] = useState(false)
    const [openBusinessActivity, setOpenBusinessActivity] = useState(false)


    useEffect(() => {
        if (user) {
            if (state?.hasSigned) {
                setTimeout(() => {
                    getData()
                }, 10000);
            } else {
                setTimeout(() => {
                    setOpenCongratulations(user?.actualContract?.contract?.status === 5 && !!user?.actualContract?.contract?.integrations?.sign?.ticket)
                }, 3000);
            }
        }
    }, [user, state])


    useEffect(() => {
        if (user?.actualContract?.contract?.status === 50 && !state?.ignoreCanceled) {
            navigate("/cliente/pedido-reprovado", {
                state: {
                    description: user?.actualContract?.contract?.canceledReason,
                    id: user?.actualContract?.contract?.id
                }
            })
        }
        if (user?.client?.needVerifyPhone) {
            setTimeout(() => {
                setOpenConfirmNumber(true)
            }, 500);
        }

        if (moment(user?.client?.lastUpdate).isBefore(Constants.activityDeployedAt)) {
            setTimeout(() => {
                setOpenBusinessActivity(true)
            }, 500);
        }
    }, [user])

    return (
        <Grid
            sx={{
                width: "100%",
                height: "100%",
            }}
        >
            <Typography color="secondary" fontWeight={900} fontSize={"2.8rem"}>Olá, {user?.name?.split(" ")[0]}</Typography>
            <Typography
                fontSize={"1.6rem"}
                fontWeight={100}
                fontFamily={"Nexa ExtraLight"}
                width={"70%"}
            >
                Pague suas diárias em dia e
            </Typography>

            <Typography
                variant="h4"
                fontWeight={900}
                fontFamily={"Nexa heavy"}
                color="secondary"
                lineHeight={"2.5rem"}
                width={"70%"}
                fontSize={"2.2rem"}
            >
                conquiste o crédito que você deseja!
            </Typography>

            <Ruler currentCredit={user?.client?.actualTable === 0 ? 1000 : Constants.creditEvolution[(user?.client?.actualTable ?? 1) - 1]} />

            <LineComponent />

            <Modalities openModalBusinessActivity={() => setOpenBusinessActivity(true)} />

            <LineComponent />

            <MyRent openModalBusinessActivity={() => setOpenBusinessActivity(true)} />

            <ModalCongratulations open={openCongratulations} onClose={() => setOpenCongratulations(false)} />

            <ModalConfirmNumber open={openConfirmNumber} onClose={() => setOpenConfirmNumber(false)} />

            <ModalBusinessActivity open={openBusinessActivity} onConfirm={() => {
                setOpenBusinessActivity(false)
                getData()
            }} onClose={() => setOpenBusinessActivity(false)} />

        </Grid>
    )
}